import React, { useState } from 'react';
import '../styles/Gallery.css';
import Modal from '../components/Modal';

const Malle = () => {
  const images = [
    'malle1.jpg',
    'malle2.jpg',
    'affichemalle.jpg',
    // ajoute d'autres fichiers ici, orthographe exacte
  ];

  const base = `${process.env.PUBLIC_URL}/album/onsefaitlamalle`;

  const [modalImage, setModalImage] = useState(null);
  const [modalAltText, setModalAltText] = useState('');

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText('');
  };

  return (
    <div className="album-detail">
      <h1>Album On se fait la malle</h1>
      <div className="image-gallery">
        {images.map((image, index) => {
          const src = `${base}/${image}`;
          return (
            <img
              key={image}
              src={src}
              alt={`Détail de l'image ${index + 1}`}
              className="album-image"
              onClick={() => openModal(src, `Détail de l'image ${index + 1}`)}
              onError={(e) => {
                // aide au debug : met en évidence les fichiers introuvables
                e.currentTarget.style.outline = '2px solid red';
                e.currentTarget.title = `Introuvable: ${src}`;
              }}
            />
          );
        })}
      </div>

      {modalImage && (
        <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />
      )}
    </div>
  );
};

export default Malle;
